import { apiInterceptor } from 'utils/apiInterceptor';
export async function ClearCacheProject(projectId) {
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API_VIRTUAL}/v1/manager/projects/${projectId}/clear-cache`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );
    return await response.json();
}
